import { render, staticRenderFns } from "./EventExtraDeviceEmissions.vue?vue&type=template&id=438807a4"
import script from "./EventExtraDeviceEmissions.vue?vue&type=script&lang=ts"
export * from "./EventExtraDeviceEmissions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports